// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3m2pD","inputWrap":"CustomTip_inputWrap__3dlbl"};